export default __webpack_public_path__ + "static/media/Abdel_Nasser_Assidi_0002.6d291a39.jpg";